module.exports = __webpack_public_path__ + "static/media/comprehensively.b063e573.svg";